export default __webpack_public_path__ + "static/media/default_coverphoto.d2a7aa88.jpeg";